/**
 * Check if a feature flag is enabled.
 * @param {string} flagName - The name of the feature flag.
 * @returns {boolean} - True if the feature flag is enabled, false otherwise.
 */
function isFeatureFlagEnabled(flagName) {
  var isNode = typeof process !== "undefined" && process.versions !== null && process.versions.node !== null;
  var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";

  // Node environment
  if (isNode) {
    var lcAppConfig = require("lc-app-config");
    return lcAppConfig.get(flagName) === "true" || lcAppConfig.get(flagName) === true;
  }

  // Browser environment
  if (isBrowser) {
    var dmr = require("dynamic-module-registry");
    var featureFlag = dmr.get("featureFlag") || {};
    return featureFlag[flagName] === "true" || featureFlag[flagName] === true;
  }
  return false;
}
module.exports = isFeatureFlagEnabled;
